import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const CirclesIcon = ({ color = '#0D84FE', size = 26, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 491 491"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M245.5 0C381.086 0 491 109.914 491 245.5S381.086 491 245.5 491 0 381.086 0 245.5 109.914 0 245.5 0zm.5 37C131.677 37 39 129.677 39 244c0 40.56 11.666 78.396 31.825 110.335 2.573-11.839 7.82-21.484 19.077-34.24C111.01 296.172 139.869 283 171.155 283s60.146 13.173 81.254 37.094c20.374 23.09 35.554 88.022 37.427 126.252 4.414-.948 8.775-2.04 13.078-3.268-1.23-41.833-17.742-105.808-40.92-131.99A126.542 126.542 0 0 0 240 291.377C260.966 268.508 289.018 256 319.782 256c31.272 0 60.12 13.125 81.218 36.96 12.18 13.762 21.325 30.673 27.052 49.634C443.964 313.284 453 279.697 453 244c0-114.323-92.677-207-207-207zm-75 124c29.823 0 54 24.4 54 54.5S200.823 270 171 270s-54-24.4-54-54.5 24.177-54.5 54-54.5zm149-27c29.823 0 54 24.4 54 54.5S349.823 243 320 243s-54-24.4-54-54.5 24.177-54.5 54-54.5z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

CirclesIcon.propTypes = propTypes;

export default CirclesIcon;
